import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-redeemed-success',
    templateUrl: './redeemed-success.component.html',
    styleUrls: ['./redeemed-success.component.scss']
})
export class RedeemedSuccessComponent implements OnInit {

    @Output() closeSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();

    progress = 0;

    constructor(public router: Router) { }

    ngOnInit() {

        this.startProgress();
    }

    onClose() {

        this.closeSuccess.emit();
    }

    onShowExchanges() {

        this.router.navigate(['/gsa-dashboard'], { queryParams: { dashboard: 0 } }); 
    }

    startProgress() {

        const interval = 100; // update each
        const duration = 2000; // duration

        setTimeout(() => this.closeSuccess.emit(), 3000)

        const step = (interval / duration) * 100;

        const timer = setInterval(() => {

            this.progress += step;

            if (this.progress >= 100) {

                clearInterval(timer);
            }

        }, interval);
    }
}
